import React, {useEffect, useState} from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';


const LinearScaleBarChart = (props) => {

    const [dataArray, setDataArray] = useState([]);

    useEffect(() => {
        var max = parseInt(props.question.max);
        var min = parseInt(props.question.min);

        var datad = [];
        for(var i = min; i < max; i++) {
            var object = {
                name : `${i}`,
                count : props.question?.answers?.filter(x => x === i)?.length
            }
            datad.push(object);
        }
        setDataArray([...datad]);

    }, [props.question])

    return (
        <BarChart
            width={window.innerWidth-500}
            height={window.innerHeight-500}
            data={dataArray}
            margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
            }}
            barSize={40}
        >
            <XAxis dataKey="name" scale="auto" padding={{ left: 20, right: 10 }} />
            <YAxis allowDecimals={false}/>
            <Tooltip />
            <CartesianGrid strokeDasharray="3 3" />
            <Bar dataKey="count" fill="#8884d8" background={{ fill: '#eee' }} />
        </BarChart>
    );
}

export default LinearScaleBarChart;
